import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiGetDashboardProductsRequest,
    type OpenApiGetDashboardProductsResponseSuccess,
} from '#shared/api/schema';

const apiDashboardProducts = createApi({
    name: 'entities/dashboard/api/products',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            get: builder.query<OpenApiGetDashboardProductsResponseSuccess, OpenApiGetDashboardProductsRequest>({
                query: () => {
                    return {
                        url: '/dashboard/products',
                    };
                },
            }),
        };
    },
});

export const useGetDashboardProducts = apiDashboardProducts.useGetQuery;
